<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-sm-12">
        <div class="row justify-content-center mb-4">
          <img src="@/assets/images/knex.png" width="20%" alt="" />
        </div>
        <div class="row justify-content-center">
          <h1>O que é?</h1>
        </div>
        <p class="lead">
          Knex.js é um criador de consultas SQL com suporte para Postgres,
          MSSQL, MySQL, MariaDB, SQLite3, Oracle e Amazon Redshift projetado
          para ser flexível, portátil e divertido de usar. Ele apresenta
          retornos de chamada de estilo de nó tradicional, bem como uma
          interface de promessa para controle de fluxo assíncrono mais limpo,
          uma interface de fluxo, consulta com recursos completos e construtores
          de esquema, suporte a transações (com pontos de salvamento), pool de
          conexão e respostas padronizadas entre diferentes clientes de consulta
          e dialetos.
        </p>
      </div>
    </div>

    <div class="col-sm-12 mt-5">
      <div class="row justify-content-center">
        <h1>Por que utilizar?</h1>
      </div>
      <p class="lead">
        Além da simplicidade oferecida pela sintaxe do knex, que é basicamente
        escrever em javascript, o knex ainda tem suporte para vários SGBDs
        diferentes o que facilita a troca do banco de dados desde que a
        modelagem seja igual.
      </p>
      <p class="lead">
        O Knex também fornece uma forma de escrever SQL caso seja necessário (e
        vai ser) a partir das funções .raw(), .whereRaw(), .joinRaw(), dentre
        outras.
      </p>
    </div>

    <div class="col-sm-12 mt-5">
      <div class="row justify-content-center">
        <h1>Onde baixar?</h1>
      </div>
      <p class="lead">
        Você pode realizar o download do Knex.js no site oficial ->
        <a target="_blank" href="https://knexjs.org/">https://knexjs.org/</a>.
        Lá você também pode encontrar tutoriais de aplicações simples,
        integrações de componentes e muito mais.
      </p>
    </div>

    <div class="text-center mt-5">
      <base-button type="primary" class="my-4" @click="scrollTop"
        >Voltar ao topo</base-button
      >
    </div>
  </div>
</template>

<script>
import { scrollTop } from "@/global";

export default {
  name: "knex-article",
  methods: { scrollTop: scrollTop },
};
</script>

<style>
</style>